import React from "react";
import heroImg from "../images/hero/hero-img.svg";
import { AppContext } from "../context";
import { useI18n } from "../i18n";
import { FaCode, FaEnvelope } from "react-icons/fa";

export const Hero = () => {
  // function from context
  const { smoothScroll } = React.useContext(AppContext);
  const { t, locale } = useI18n();

  // jsx
  return (
    <header id="home">
      <div className="banner">
        <div className="banner-container section-center">
          {/* hero-info */}
          <article className="hero-info">
            {/*
              La salutation animée reste le titre visuel, mais ce n'est plus
              le <h1> : le <h1> porte le rôle et la localisation, c'est-à-dire
              ce sur quoi on veut être trouvé.
            */}
            <p id="my-name" className={locale === "en" ? "name-en" : ""}>
              {t.hero.greeting} <br />
              <span>{t.hero.name}</span>
            </p>
            <h1 className="hero-role">{t.hero.role}</h1>
            <p>{t.hero.pitch}</p>
            <div className="hero-btn-container">
              <a
                href="#projects"
                className="btn hero-btn"
                onClick={(e) => smoothScroll(e)}
                title={t.hero.btnProjects}
              >
                {t.hero.btnProjects} <FaCode className="fa" />
              </a>
              <a
                href="mailto:nkenguestephane0@gmail.com"
                className="btn hero-btn"
                title={t.hero.btnContact}
              >
                {t.hero.btnContact} <FaEnvelope className="fa" />
              </a>
            </div>
          </article>

          {/* hero-image */}
          <article className="hero-img">
            <img
              src={heroImg}
              alt={t.hero.imgAlt}
              className="hero-image"
              width="400"
              height="480"
            />
          </article>
        </div>
      </div>
    </header>
  );
};
